import { useOnline } from "@vueuse/core";
import { computed } from "vue";
import { contextExchange } from "./changeReqContext";

export const preventOfflineQueriesExchange = contextExchange(ctx => {
  const isOnline = useOnline();
  return {
    ...ctx,
    requestPolicy: computed(() =>
      isOnline.value ? ctx.requestPolicy : "cache-only"
    ).value
  };
});
